var processInclude = require("./util");

$(document).ready(function () {
    // Since categoryLayout.js renders a carousel containing the eight-advertising-layout and three-advertising-layout classes,
    // and taking in consideration that the Page-ManagerDecisionBanner (endpoint that retrieves the ads form Kevel Ad Server) takes up-to ~1.8 seconds to retrieve the data and the carousel is quicker to load.
    // However, the carousel can't load before, or else the it will show no items in these cases.
    // Therefore, a delay of 1.9 seconds is necessary, to ensure the carousel is correctly rendered. This is mobile only.
    setTimeout(() => {
        processInclude(require("./categoryLanding/category2Layout"));
    }, 1900);
});
